import { Box, BoxProps } from "@chakra-ui/react";

export function CustomerCenterIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
        stroke="none"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 1.2915C4.74281 1.2915 1.29167 4.74264 1.29167 8.99984C1.29167 13.257 4.74281 16.7082 9 16.7082C13.2572 16.7082 16.7083 13.257 16.7083 8.99984C16.7083 4.74264 13.2572 1.2915 9 1.2915ZM0.0416679 8.99984C0.0416679 4.05229 4.05245 0.0415039 9 0.0415039C13.9476 0.0415039 17.9583 4.05229 17.9583 8.99984C17.9583 13.9474 13.9476 17.9582 9 17.9582C4.05245 17.9582 0.0416679 13.9474 0.0416679 8.99984Z"
          //fill="#5C6670"
        />
        <path
          d="M9 5.4585C8.4247 5.4585 7.95833 5.92487 7.95833 6.50016C7.95833 6.84534 7.67851 7.12516 7.33333 7.12516C6.98815 7.12516 6.70833 6.84534 6.70833 6.50016C6.70833 5.23451 7.73435 4.2085 9 4.2085C10.2657 4.2085 11.2917 5.23451 11.2917 6.50016C11.2917 6.95544 11.1583 7.38147 10.9282 7.73902C10.7841 7.96297 10.6156 8.17678 10.4602 8.36986C10.4318 8.40518 10.4039 8.43974 10.3765 8.47371C10.2476 8.63325 10.1292 8.7797 10.0199 8.92997C9.75024 9.30057 9.625 9.57908 9.625 9.8335V10.2502C9.625 10.5953 9.34518 10.8752 9 10.8752C8.65482 10.8752 8.375 10.5953 8.375 10.2502V9.8335C8.375 9.16744 8.70201 8.61664 9.00913 8.19454C9.13891 8.01618 9.28111 7.84028 9.41042 7.68032C9.43632 7.64828 9.46171 7.61689 9.48637 7.58624C9.64069 7.39444 9.77206 7.2257 9.877 7.06262C9.98117 6.90073 10.0417 6.70847 10.0417 6.50016C10.0417 5.92487 9.5753 5.4585 9 5.4585Z"
          //fill="#5C6670"
        />
        <path
          d="M8.16 13.1668C8.16 12.7066 8.53309 12.3335 8.99333 12.3335H9.00081C9.46105 12.3335 9.83415 12.7066 9.83415 13.1668C9.83415 13.6271 9.46105 14.0002 9.00081 14.0002H8.99333C8.53309 14.0002 8.16 13.6271 8.16 13.1668Z"
          //fill="#5C6670"
        />
      </svg>
    </Box>
  );
}
